// pages/MMChatStatsPage.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { httpsCallable } from "firebase/functions";
import { functions, db } from "../api/firebase";
import { doc, getDoc } from "firebase/firestore";

const MMChatStatsPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nextOffset, setNextOffset] = useState(0);
  const [autoLoading, setAutoLoading] = useState(true); // ← 自動継続

  // Firestore から group name を取得
  const fetchGroupName = async (cid) => {
    const groupId = cid.replace("messaging:", ""); // ← xxx を抽出
    try {
      const snap = await getDoc(doc(db, "groups2025halfSecond", groupId));
      if (snap.exists()) {
        return snap.data().name || groupId;
      }
    } catch (e) {
      console.error("Group fetch error", groupId, e);
    }
    return groupId; // fallback
  };

  const fetchNextBatch = async (offset = 0) => {
    setLoading(true);
    try {
      const getStats = httpsCallable(functions, "getChatStatsSince202508");
      const res = await getStats({ offset, limit: 20 });
      const data = res?.data || {};
      const list = data.rows || [];

      // cid → group name へ変換
      const listWithNames = await Promise.all(
        list.map(async (r) => {
          const groupName = await fetchGroupName(r.cid);
          return { ...r, groupName };
        })
      );

      setRows((prev) => [...prev, ...listWithNames]);
      setNextOffset(data.nextOffset);

      console.log("追加取得:", listWithNames.length, "件 (offset:", offset, ")");
    } catch (e) {
      console.error("getChatStatsSince202508 error:", e);
    } finally {
      setLoading(false);
    }
  };

  // 初回ロード & 自動ページング
  useEffect(() => {
    if (autoLoading && nextOffset !== null) {
      fetchNextBatch(nextOffset);
    }
  }, [nextOffset, autoLoading]);

  return (
    <Box p={2}>
      <Typography variant="h6" gutterBottom>
        チャット集計（自動ページング）
      </Typography>

      <Paper variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>グループ名</TableCell>
              <TableCell align="right">メッセージ数</TableCell>
              <TableCell align="right">発言者数</TableCell>
              <TableCell>作成日時</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.cid}>
                <TableCell>{r.groupName}</TableCell>
                <TableCell align="right">{r.messageCount}</TableCell>
                <TableCell align="right">{r.uniqueSpeakers}</TableCell>
                <TableCell>{r.createdAt || "-"}</TableCell>
              </TableRow>
            ))}
            {loading && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress size={20} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default MMChatStatsPage;
